import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function Row({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      gap={{ base: 1, lg: 1.5 }}
      fontSize={{ base: "8px", lg: "9px", xl: "11px" }}
      flexWrap={{ base: "wrap", lg: "nowrap" }}
      {...props}
    >
      {children}
    </Flex>
  );
}
